import '../MultiViewWidget.css';
import {getFieldThreshold,evaluateThreshold,evaluatePercentageThreshold} from './utils';
import { useTheme } from 'styled-components';

const MetricCard = ({widget ,data}:any) => {

  const theme = useTheme();
  const isPositive = data?.change >= 0;
  const {fields} = widget;
  const threshold = getFieldThreshold(data.name, fields);
  const thresholdResult = threshold?.threshold?.type === 'percentage'? 
  evaluatePercentageThreshold(data.count, data.total, threshold?.threshold) :
  evaluateThreshold(data.count, threshold?.threshold);
  
  return (
    <div style={{height: widget.height || '100%' }}>
      <div className="metric-value">
        <span style={{ color: thresholdResult?.color || (theme.darkMode ? '#f9fafb' : '#1a1a1a')}}>{data?.label || data?.count}</span>
      </div>
      <div className={`metric-change ${isPositive ? 'positive' : 'negative'}`}>
        {data?.change && <span>{isPositive ? '↑' : '↓'}</span> }
        {data?.change && <span>{Math.abs(data?.change)}%</span> }
        {data?.trend &&<span className="trend">{data?.trend}</span> }
      </div>
    </div>
  );
};

export default MetricCard;